import type { FC } from 'react';
import { Button } from '@george-labs.com/design-system';

import { AliasChangeDropdown } from '@retail/products-customisation';
import { t } from '@luna/i18n';
import { useActiveCustomizationFeature } from '@shared/products-core';
import { CustomizationService } from '@api-client/products';

import { useCustomizationSuccessHandler } from './hooks/useCustomizationSuccessHandler';
import { useActivePAPIProduct } from '../../../ActivePAPIProductContext';

export const AliasChange: FC = () => {
    const { activateAliasChangeCustomization } = useActiveCustomizationFeature();
    const handleSuccessfulCustomization = useCustomizationSuccessHandler();

    const {
        localizedName,
        id,
        _embedded: {
            customization: { name, changes },
        },
    } = useActivePAPIProduct();

    const updateAlias = async (alias: string) => {
        CustomizationService.putPublicProductsCustomizationName({
            id,
            requestBody: { name: alias },
        }).then(handleSuccessfulCustomization);
    };

    return (
        <AliasChangeDropdown
            alias={name}
            hasAlias={changes.includes('NAME')}
            aliasChangeContext="dashboard"
            onAliasSave={updateAlias}
            productType={localizedName}
            toggle={
                <Button
                    icon={Button.ICON.EDIT}
                    size={Button.SIZE.SMALL}
                    onClick={activateAliasChangeCustomization}
                    data-cy="product-settings-edit-alias-button"
                    className="g-inverted"
                >
                    {t('mainOverview.action.changeName_a11y')}
                </Button>
            }
            placeholder={localizedName}
            trigger="productDetail"
        />
    );
};
